const chunkLoadErrorRx = /Loading chunk \d+ failed./;
const isChunkLoadError = error => chunkLoadErrorRx.test(error.message);

/**
 * Filter to prevent logging errors resulting from the failure to load a bundle
 * chunk - they are not actionable and will resolve themselves.
 */
export class ChunkLoadFilter {
  isLoggable(record) {
    const [maybeError] = record.messages;
    // If the message is not an instance of Error, we should log it
    if (!(maybeError instanceof Error)) {
      return true;
    }

    // If the error does not have a cause or the cause is not an instance of Error,
    // we should log it
    const cause = maybeError.cause;
    if (!(cause instanceof Error)) {
      return true;
    }

    // If the cause is not a chunk load error, we should log it
    if (!isChunkLoadError(cause)) {
      return true;
    }

    // If the cause is a chunk load error, we should not log it
    return false;
  }
}